export default __webpack_public_path__ + "static/media/src_repairapp_desk_3.eb038257.jpg";